<section class="pt-2">
  <div class="container-style">
    <div class="row align-items-center pb-2">
      <div class="col-lg-6 col-md-12 col-sm-12 col-12">
        <h6>
          {{ isFormView ? 'Editar detalle de factura de transporte' : 'Detalle de factura de transporte' }}
        </h6>
      </div>
      <div class="col-lg-6 col-md-12 col-sm-12 col-12 d-flex justify-content-end">
        <app-custom-button [label]="'Agregar Docs.'" [severity]="'success'"
          [disabled]="disabledButton || !providerId || providerId === 0" [width]="'7rem'"
          (onClick)="openDocumentSelectionModal()"></app-custom-button>
        <app-custom-modal #documentSelection [label]="'Seleccionar'" [header]="'Agregar Documentos de Transporte'"
          [children]="componentTableSelection" [inputs$]="inputsForDocumentSelection$" [output$]="output$"
          [width]="'60vw'" (selectedItems)="handleSelectedItems($event)" hidden></app-custom-modal>
      </div>
    </div>
    <div class="row mx-0" [hidden]="!isFormView">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12 border">
        <app-register-transport-invoice-detail [transportInvoiceId]="transportInvoiceId"
          [transportInvoiceDetail]="transportInvoiceDetail" [permissionUpdatable]="permissionUpdatable"
          (isFormView)="getFormView($event)" (updateListDetail)="getTransportInvoiceDetails()">
        </app-register-transport-invoice-detail>
      </div>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-12 border">
      <app-custom-table [headers]="detailHeader" [data]="detailData" [actions]="tableActions"
        [showCheckbox]="!this.disabledButton" [checkBoxAction]="checkboxActions"
        [clearSelectionTrigger]="clearSelectionTrigger" (onRecoverData)="getTransportInvoiceDetails()"
        (onPageChange)="onPageChange($event)" (onAction)="onAction($event)">
      </app-custom-table>
    </div>
  </div>
</section>